<script>
  import Pattern from './pattern/pattern.svelte'
  import Canvas from './pattern/canvas.svelte'
  import { top, bottom } from './pattern/patterns'

  let viewportWidth, viewportHeight

  const topPatterns = top[Math.floor(Math.random() * top.length)]
  const bottomPatterns = bottom[Math.floor(Math.random() * bottom.length)]
</script>

<style>
  .fixed {
    position: fixed;
    top: 0;
    left: 0;
    height: 100vh;
    width: 100%;
    background-image: linear-gradient(var(--background-from), var(--background-to));
    z-index: -2;
  }

  .canvas {
    position: absolute;
    width: 100%;
    z-index: -1;
    overflow: hidden;
  }
  .canvas.topp {
    top: 0;
  }
  .canvas.bunn {
    bottom: 0;
  }
</style>

<svelte:window bind:innerWidth={viewportWidth} bind:innerHeight={viewportHeight} />

<div class="fixed" />

<div class="canvas topp">
  <Canvas width={viewportWidth} height={viewportHeight}>
    {#each topPatterns as pattern}
      <Pattern {...pattern(viewportWidth, viewportHeight)} />
    {/each}
  </Canvas>
</div>

<div class="canvas bunn">
  <Canvas width={viewportWidth} height={viewportHeight}>
    {#each bottomPatterns as pattern}
      <Pattern {...pattern(viewportWidth, viewportHeight)} />
    {/each}
  </Canvas>
</div>
